// extracted by mini-css-extract-plugin
export default {"reactionsContainer":"o1eWAz"};